module.exports = __webpack_public_path__ + "static/Pterodactyl Panel-2a75dba8dd56c94d39eae14de97fdc70.svg";